var React = require('react');

function Alert (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"m21.84 19.83-8.5-17a1.5 1.5 0 0 0-2.68 0l-8.5 17A1.49 1.49 0 0 0 3.5 22h17a1.49 1.49 0 0 0 1.34-2.17zM11.25 18a.75.75 0 0 1 1.28-.53.74.74 0 0 1 .16.82.74.74 0 0 1-.4.4.72.72 0 0 1-.58 0 .78.78 0 0 1-.24-.16.631.631 0 0 1-.16-.24.753.753 0 0 1-.06-.29zm.75-2.25a.75.75 0 0 0 .75-.75V9a.75.75 0 1 0-1.5 0v6c0 .414.336.75.75.75z","fill":"#F9587A"}));
}

Alert.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Alert;

Alert.default = Alert;
